module.exports = __webpack_public_path__ + "img/logoptp.a205aa38.svg";